export const gameConfigList = [{
    name: "全人发展卡",
    tag: "perfect",
    cateId: 1,
    secondCateId: null,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },

  {
    name: "亲子关系平衡轮 文字",
    tag: "parenting_text",
    cateId: 18,
    secondCateId: 20,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "亲子关系平衡轮 打分",
    tag: "parenting_wheel",
    cateId: 18,
    secondCateId: 19,
    flip: true,
    gameType: 3,
    limitNum: null,
    visibleType: 'wheel'
  },

  {
    name: "生命平衡轮 文字",
    tag: "life_text",
    cateId: 17,
    secondCateId: 22,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "生命平衡轮 打分",
    tag: "life_wheel",
    cateId: 17,
    secondCateId: 21,
    flip: true,
    gameType: 3,
    limitNum: null,
    visibleType: 'wheel'
  },
  {
    name: "全人发展卡 打分",
    tag: "perfect_wheel",
    cateId: 1,
    secondCateId: 2,
    flip: true,
    gameType: 3,
    limitNum: null,
    visibleType: 'wheel'
  },
  {
    name: "全人发展卡 文字",
    tag: "perfect_text",
    cateId: 1,
    secondCateId: 13,
    flip: true,
    gameType: 2,
    visibleType: 'card'
  },
  {
    name: "全人发展卡 图片",
    tag: "perfect_img",
    cateId: 1,
    secondCateId: 14,
    flip: true,
    gameType: 2,
    visibleType: 'card'
  },
  {
    name: "情绪卡",
    tag: "emotion",
    cateId: 12,
    secondCateId: null,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "情绪卡 文字",
    tag: "emotion_text",
    cateId: 12,
    secondCateId: 15,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "情绪卡 盲抽",
    tag: "emotion_draw",
    cateId: 12,
    secondCateId: 16,
    flip: false,
    gameType: 4,
    limitNum: 1,
    visibleType: 'draw'
  },
  {
    name: "价值观卡",
    tag: "values",
    cateId: 8,
    secondCateId: null,
    flip: true,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "价值观卡 文字",
    tag: "values_text",
    cateId: 8,
    secondCateId: 9,
    flip: true,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "价值观卡 图画",
    tag: "values_img",
    cateId: 8,
    secondCateId: 10,
    flip: true,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "价值观卡 盲抽",
    tag: "values_draw",
    cateId: 8,
    secondCateId: 11,
    flip: true,
    gameType: 4,
    limitNum: 1,
    visibleType: 'draw'
  },

  {
    name: "父母行为红绿灯卡 红",
    tag: "parent_red",
    cateId: 4,
    secondCateId: 5,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "父母行为红绿灯卡 绿",
    tag: "parent_green",
    cateId: 4,
    secondCateId: 7,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },
  {
    name: "父母行为红绿灯卡 黄",
    tag: "parent_yellow",
    cateId: 4,
    secondCateId: 6,
    flip: false,
    gameType: 6,
    visibleType: 'card'
  },
]
export function getGameConfig(cateId, secondCateId) {
  let gameConfig = gameConfigList.find(item => {
    return item.cateId == cateId && item.secondCateId == secondCateId
  })
  return gameConfig
}

export function getGameConfigByTag(tag) {
  let gameConfig = gameConfigList.find(item => {
    return item.tag == tag
  })
  return gameConfig
}